import React, { useState, useEffect, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiAward, FiDownload, FiFilter, FiUser, FiCalendar, FiEdit3, FiAlertTriangle, FiAlertCircle, FiX } from 'react-icons/fi';
import { db, auth } from '../../firebase';
import { doc, getDoc, collection, getDocs, updateDoc, writeBatch } from 'firebase/firestore';
import * as XLSX from 'xlsx';

// --- GLOBÁLIS KONSTANSOK A RENDEZÉSHEZ ---
const AGE_ORDER = {
  'mini': 1,
  'gyerek': 2,
  'junior': 3,
  'kadet': 4,
  'ifi': 5, 'ifjúsági': 5,
  'fiatal_felnott': 6, 'fiatal felnőtt': 6,
  'felnott': 7, 'felnőtt': 7,
  'szenior': 8, 'senior': 8,
  'veteran': 9, 'veterán': 9
};

const bowTranslationMap = {
  'tortenelmi_ij': 'Történelmi íj',
  'tortenelmi': 'Történelmi',
  'tortenelmi_vadaszij_fa': 'Vadászíj fa vesszővel',
  'tortenelmi_vadaszij_karbon': 'Vadászíj karbonvesszővel',
  'tortenelmi_vadaszij': 'Hagyományos vadászíj',
  'tortenelmi_pusztai_modern': 'Modern pusztai íj',
  'tortenelmi_pusztai_termeszetes': 'Természetes pusztai íj',
  'tortenelmi_botij': 'Történelmi hosszúíj / Botíj',
  'tortenelmi_szamszerij': 'Történelmi számszeríj',
  'tortenelmi_bb': 'BB (Barebow - Vendég kategória)',
  '3d_hdh_bb': 'BB (Barebow)',
  '3d_hdh_bg': 'BG (Fúvócső)',
  '3d_hdh_cb': 'CB (Csigás Barebow)',
  '3d_hdh_crb': 'CRB (Számszeríj)',
  '3d_hdh_cu': 'CU (Scope-os Csigás)',
  '3d_hdh_hu': 'HU (Vadász Csigás)',
  '3d_hdh_ol': 'OL (Olimpiai)',
  '3d_hdh_pbhb': 'PBHB (Tradi)',
  '3d_hdh_trlb': 'TRLB (Longbow)',
  '3d_hdh_trrb': 'TRRB (Vadászreflex)',
  '3d_ifaa_bbc': 'BB(C) (Barebow-Csigás)',
  '3d_ifaa_bbr': 'BB(R) (Barebow-Reflex)',
  '3d_ifaa_bhc': 'BH(C) (Vadászijász-Csigás)',
  '3d_ifaa_bhr': 'BH(R) (Vadászijász-Reflex)',
  '3d_ifaa_bl': 'BL (Korlátozott Vadászijász)',
  '3d_ifaa_bu': 'BU (Bowhunter Unlimited)',
  '3d_ifaa_fsc': 'FS(C) (Korl. nyílt o.-Csigás)',
  '3d_ifaa_fsr': 'FS(R) (Korl. nyílt o.-Reflex)',
  '3d_ifaa_fu': 'FU (Korlátlan nyílt osztály)',
  '3d_ifaa_hb': 'HB (Történelmi íj)',
  '3d_ifaa_hbm': 'HB(M) (Történelmi íj modern)',
  '3d_ifaa_lb': 'LB (Longbow)',
  '3d_ifaa_tr': 'TR (Tradicionális reflex)',
  'terep_olimpiai': 'OL (Olimpiai)',
  'terep_csigas': 'CU (Scope-os Csigás)',
  'terep_barebow': 'BB (Barebow)',
  'terep_cb': 'CB (Csigás Barebow)',
  'terep_hu': 'HU (Vadász Csigás)',
  'terep_pbhb': 'PBHB (Tradi - Pusztai íj)',
  'terep_trlb': 'TRLB (Longbow)',
  'terep_trrb': 'TRRB (Vadászreflex)',
  'palya_wa_ol': 'R (Olimpiai reflexíj)',
  'palya_wa_cu': 'CU (Scope-os Csigás)',
  'palya_wa_hu': 'HU (Vadász Csigás)',
  'palya_wa_bb': 'B (Barebow)',
  'palya_wa_trrb': 'TRRB (Vadászreflex)',
  'palya_wa_trlb': 'TRLB (Longbow)',
  'palya_wa_pbhb': 'PBHB (Tradi - Pusztai íj)',
  'palya_wa_crb': 'CRB (Számszeríj)',
  'palya_ifaa_fu': 'FU (Freestyle Unlimited)',
  'palya_ifaa_fsr': 'FSR (Freestyle Ltd Recurve)',
  'palya_ifaa_fsc': 'FSC (Freestyle Ltd Compound)',
  'palya_ifaa_bbr': 'BBR (Barebow Recurve)',
  'palya_ifaa_bbc': 'BBC (Barebow Compound)',
  'palya_ifaa_bu': 'BU (Bowhunter Unlimited)',
  'palya_ifaa_bl': 'BL (Bowhunter Limited)',
  'palya_ifaa_bhc': 'BHC (Bowhunter Compound)',
  'palya_ifaa_bhr': 'BHR (Bowhunter Recurve)',
  'palya_ifaa_lb': 'LB (Longbow)',
  'palya_ifaa_hb': 'HB (Historical Bow)',
  'palya_ifaa_tr': 'TR (Traditional Bow)',
  'orom_wa_ol': 'OL (Olimpiai reflexíj)',
  'orom_wa_cu': 'CU (Scope-os Csigás)',
  'orom_wa_hu': 'HU (Vadász Csigás)',
  'orom_wa_cb': 'CB (Csigás Barebow)',
  'orom_wa_bb': 'BB (Barebow)',
  'orom_wa_trrb': 'TRRB (Vadászreflex)',
  'orom_wa_trlb': 'TRLB (Longbow)',
  'orom_wa_pbhb': 'PBHB (Pusztai íj)',
  'orom_vadaszij_fa': 'Vadászíj fa vesszővel',
  'orom_vadaszij_karbon': 'Vadászíj karbon vesszővel',
  'orom_tortenelmi_ij': 'Történelmi íj',
  'orom_wa_crb': 'CRB (Számszeríj)',
  'orom_wa_bg': 'BG (Fúvócső)',
  'egyeb_wa_ol': 'OL (Olimpiai reflexíj)',
  'egyeb_wa_cu': 'CU (Scope-os Csigás)',
  'egyeb_wa_hu': 'HU (Vadász Csigás)',
  'egyeb_wa_cb': 'CB (Csigás Barebow)',
  'egyeb_wa_bb': 'BB (Barebow)',
  'egyeb_wa_trrb': 'TRRB (Vadászreflex)',
  'egyeb_wa_trlb': 'TRLB (Longbow)',
  'egyeb_wa_pbhb': 'PBHB (Pusztai íj)',
  'egyeb_wa_crb': 'CRB (Számszeríj)',
  'egyeb_wa_bg': 'BG (Fúvócső)',
  'egyeb_altalanos': 'Egyéb Általános'
};

// Normalizáló segédfüggvények
const removeAccents = (str) => {
  if (!str) return "";
  return str
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ď/g, "d")
    .replace(/ť/g, "t")
    .replace(/ň/g, "n")
    .replace(/ř/g, "r")
    .replace(/š/g, "s")
    .replace(/č/g, "c")
    .replace(/ž/g, "z")
    .replace(/ĺ/g, "l")
    .replace(/ľ/g, "l")
    .replace(/ŕ/g, "r");
};

const formatCategory = (cat) => {
  if (!cat) return "Egyéb";
  const lower = removeAccents(cat.toString().toLowerCase().trim());
  if (bowTranslationMap[lower]) return bowTranslationMap[lower];
  return cat.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase());
};

const translationMap = {
  'mini': 'Mini', 'gyerek': 'Gyerek', 'junior': 'Junior', 'kadet': 'Kadét', 'ifi': 'Ifi',
  'ifjúsági': 'Ifjúsági', 'fiatal_felnott': 'Fiatal felnőtt', 'felnott': 'Felnőtt',
  'felnőtt': 'Felnőtt', 'szenior': 'Senior', 'senior': 'Senior', 'veteran': 'Veterán', 'veterán': 'Veterán'
};

const SCORING_RULE_LABELS = {
  'best_two': 'Legjobb két verseny pontszáma összeadódik'
};

// Normalizáló segédfüggvények
const AGE_ALIASES = {
  'mini': 'mini',
  'gyerek': 'gyerek',
  'junior': 'junior',
  'kadet': 'kadet', 'kadét': 'kadet',
  'ifi': 'ifi', 'ifjusagi': 'ifi', 'ifjúsági': 'ifi',
  'fiatal_felnott': 'felnott', 'fiatal felnőtt': 'felnott', 'fiatal felnott': 'felnott',
  'felnott': 'felnott', 'felnőtt': 'felnőtt',
  'szenior': 'szenior', 'senior': 'szenior',
  'veteran': 'veteran', 'veterán': 'veteran'
};

const normalizeAge = (age) => {
  if (!age) return "felnott";
  const clean = removeAccents(age.toString().toLowerCase().trim());
  return AGE_ALIASES[clean] || clean;
};
const normalizeGender = (gender) => {
  const g = (gender || "").toString().toLowerCase().trim();
  if (g.startsWith('n')) return 'nő';
  if (g.startsWith('f')) return 'férfi';
  return g;
};

const TournamentSummary = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [tournament, setTournament] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState(null);
  const [mergedData, setMergedData] = useState({}); // { category: [athletes] }
  const [potentialDuplicatesCount, setPotentialDuplicatesCount] = useState(0);

  // --- ÚJ: SZÉTLÖVÉS ÁLLAPOTOK ---
  const [showShootOffModal, setShowShootOffModal] = useState(false);
  const [shootOffGroup, setShootOffGroup] = useState([]);
  const [tempRanks, setTempRanks] = useState({}); // { key: rank }
  const [isSavingShootOff, setIsSavingShootOff] = useState(false);

  // --- ÖSSZEVONÁSI ÁLLAPOTOK ---
  const [mergeMode, setMergeMode] = useState(false);
  const [selectedKeys, setSelectedToMerge] = useState([]);
  const [showMergeModal, setShowMergeModal] = useState(false);
  const [primaryAthlete, setPrimaryAthlete] = useState(null);
  const [isMerging, setIsMerging] = useState(false);

  const fetchData = async () => {
      try {
        setLoading(true);
        const tRef = doc(db, "tournaments", id);
        const tSnap = await getDoc(tRef);
        if (!tSnap.exists()) {
          alert("A kupa nem található!");
          navigate('/egyesulet-dashboard');
          return;
        }
        const tData = { id: tSnap.id, ...tSnap.data() };
        setTournament(tData);

        const importedRef = collection(db, "tournaments", id, "importedResults");
        const importedSnap = await getDocs(importedRef);
        const allImported = {};
        importedSnap.forEach(doc => {
          allImported[doc.data().roundIndex] = doc.data().results || [];
        });

        const liveResults = {};
        for (const [idx, round] of (tData.rounds || []).entries()) {
          if (round.eventId) {
            const pRef = collection(db, "events", round.eventId, "participants");
            const pSnap = await getDocs(pRef);
            if (pSnap.empty) {
               const pClosedRef = collection(db, "events_closed", round.eventId, "participants");
               const pClosedSnap = await getDocs(pClosedRef);
               liveResults[idx] = pClosedSnap.docs.map(d => ({ id: d.id, ...d.data() }));
            } else {
               liveResults[idx] = pSnap.docs.map(d => ({ id: d.id, ...d.data() }));
            }
          }
        }

        const athleteMap = {};
        const processAthlete = (athlete, roundIdx) => {
          const rawCat = athlete.category || athlete.bowCategory || "Egyéb";
          const cat = formatCategory(rawCat);
          const lic = (athlete.license || athlete.competitionId || "").toString().trim();
          const name = (athlete.name || athlete.fullName || "Névtelen").toString().trim();
          const age = athlete.ageGroup || athlete.ageCategory || "felnott";
          const gender = athlete.gender || "Férfi";
          const club = athlete.club || athlete.organizingClub || "";

          const cleanName = removeAccents(name.toLowerCase().replace(/\s/g, ''));
          const normAge = normalizeAge(age);
          const normGender = normalizeGender(gender);

          const nameBasedKey = `${cat}|${cleanName}|${normAge}|${normGender}`;
          const existingKeys = Object.keys(athleteMap);

          let targetKey = null;

          // 1. Megkeressük, hogy van-e már név + kategória + korosztály + nem alapján megegyező versenyző
          const nameMatchKey = existingKeys.find(k => {
            const entry = athleteMap[k];
            const entryCleanName = removeAccents((entry.name || '').toLowerCase().replace(/\s/g, ''));
            const entryNormAge = normalizeAge(entry.age);
            const entryNormGender = normalizeGender(entry.gender);

            return entry.category === cat &&
                   entryCleanName === cleanName &&
                   entryNormAge === normAge &&
                   entryNormGender === normGender;
          });

          if (nameMatchKey) {
            const existingEntry = athleteMap[nameMatchKey];
            // Ha mindkettőnek van nem-üres engedélyszáma, de ELTÉRNEK, akkor ők 2 külön ember!
            if (lic && existingEntry.license && lic !== existingEntry.license) {
              targetKey = lic ? `${cat}|${lic}` : `${nameBasedKey}_${Date.now()}`;
            } else {
              targetKey = nameMatchKey;
            }
          } else if (lic) {
            // 2. Ha név alapján nem volt meccs, de van engedélyszám, keresünk engedélyszám alapján
            const licMatchKey = existingKeys.find(k => athleteMap[k].category === cat && athleteMap[k].license === lic);
            if (licMatchKey) {
              targetKey = licMatchKey;
            } else {
              targetKey = `${cat}|${lic}`;
            }
          } else {
            targetKey = nameBasedKey;
          }

          if (!athleteMap[targetKey]) {
            athleteMap[targetKey] = {
              name,
              license: lic,
              category: cat,
              age,
              gender,
              club,
              scores: Array(tData.roundCount || 1).fill(null)
            };
          }

          const points = athlete.points !== undefined ? athlete.points : (athlete.totalScore || 0);
          athleteMap[targetKey].scores[roundIdx] = points;

          // Ha az új fordulóban megvan az engedélyszám, de a meglévőnél még hiányzott, beírjuk!
          if (lic && !athleteMap[targetKey].license) {
            athleteMap[targetKey].license = lic;
          }
          if (athlete.fullName || athlete.name) {
            if (!athleteMap[targetKey].club || athleteMap[targetKey].club === 'Egyéni induló') athleteMap[targetKey].club = club;
          }
        };

        for (let i = 0; i < (tData.roundCount || 1); i++) {
          if (allImported[i]) allImported[i].forEach(a => processAthlete(a, i));
          if (liveResults[i]) liveResults[i].forEach(a => processAthlete(a, i));
        }

        // Duplikáció keresés (ékezet mentes név alapján)
        const nameDups = {};
        Object.values(athleteMap).forEach(a => {
            const cleanName = removeAccents(a.name.toLowerCase().replace(/\s/g, ''));
            const dupKey = `${a.category}|${cleanName}|${normalizeAge(a.age)}|${normalizeGender(a.gender)}`;
            if (!nameDups[dupKey]) nameDups[dupKey] = [];
            nameDups[dupKey].push(a.name);
        });

        let dupsCount = 0;
        const duplicateGroups = new Set();
        Object.entries(nameDups).forEach(([key, names]) => {
            const uniqueNames = new Set(names);
            if (uniqueNames.size > 1) {
                dupsCount++;
                duplicateGroups.add(key);
            }
        });
        setPotentialDuplicatesCount(dupsCount);

        const finalData = {};
        Object.values(athleteMap).forEach(athlete => {
          if (!finalData[athlete.category]) finalData[athlete.category] = [];

          // Megjelöljük a versenyzőt, ha gyanús csoportba tartozik
          const cleanName = removeAccents(athlete.name.toLowerCase().replace(/\s/g, ''));
          const dupKey = `${athlete.category}|${cleanName}|${normalizeAge(athlete.age)}|${normalizeGender(athlete.gender)}`;
          athlete.isPotentialDuplicate = duplicateGroups.has(dupKey);

          finalData[athlete.category].push(athlete);
        });

        Object.keys(finalData).forEach(cat => {
          finalData[cat] = finalData[cat].map(a => {
            const validScores = a.scores.filter(s => s !== null).sort((a, b) => b - a);
            let total = 0;
            if (tData.scoringRule === 'best_two') {
              total = validScores.slice(0, 2).reduce((sum, s) => sum + s, 0);
            } else {
              total = validScores.reduce((sum, s) => sum + s, 0);
            }
            return { ...a, total };
          });

          finalData[cat].sort((a, b) => {
            const ageA = AGE_ORDER[normalizeAge(a.age)] || 99;
            const ageB = AGE_ORDER[normalizeAge(b.age)] || 99;
            if (ageA !== ageB) return ageA - ageB;

            const genA = normalizeGender(a.gender) === 'nő' ? 1 : 2;
            const genB = normalizeGender(b.gender) === 'nő' ? 1 : 2;
            if (genA !== genB) return genA - genB;

            // Pontszám (csökkenő)
            if (b.total !== a.total) return b.total - a.total;

            // Ha a pontszám is egyenlő, nézzük a rögzített szétlövés eredményt (ha van)
            const aKey = a.license ? `${cat}|${a.license}` : `${cat}|${a.name}`;
            const bKey = b.license ? `${cat}|${b.license}` : `${cat}|${b.name}`;

            const rankA = tData.shootOffRanks?.[aKey] || 999;
            const rankB = tData.shootOffRanks?.[bKey] || 999;

            if (rankA !== rankB) return rankA - rankB; // Kisebb rank (1.) a jobb

            return 0;
          });

          // HOLTVERSENY DETEKTÁLÁSA (needsShootOff jelölés)
          const isShootOffEnabled = tData.tieBreakerRule === 'shoot_off';

          for (let i = 0; i < finalData[cat].length; i++) {
            const current = finalData[cat][i];
            const prev = finalData[cat][i - 1];
            const next = finalData[cat][i + 1];

            const currentKey = current.license ? `${cat}|${current.license}` : `${cat}|${current.name}`;

            const isSameGroupAsPrev = prev && normalizeAge(current.age) === normalizeAge(prev.age) && normalizeGender(current.gender) === normalizeGender(prev.gender);
            const isSameGroupAsNext = next && normalizeAge(current.age) === normalizeAge(next.age) && normalizeGender(current.gender) === normalizeGender(next.gender);

            const hasRank = tData.shootOffRanks?.[currentKey];
            const tiedWithPrev = isSameGroupAsPrev && current.total === prev.total && !hasRank && (!prev.license ? !tData.shootOffRanks?.[`${cat}|${prev.name}`] : !tData.shootOffRanks?.[`${cat}|${prev.license}`]);
            const tiedWithNext = isSameGroupAsNext && current.total === next.total && !hasRank && (!next.license ? !tData.shootOffRanks?.[`${cat}|${next.name}`] : !tData.shootOffRanks?.[`${cat}|${next.license}`]);

            if (isShootOffEnabled && (tiedWithPrev || tiedWithNext)) {
              current.needsShootOff = true;
            } else {
              current.needsShootOff = false;
            }
          }
        });

        setMergedData(finalData);
        const sortedCats = Object.keys(finalData).sort();
        if (!activeCategory && sortedCats.length > 0) setActiveCategory(sortedCats[0]);

      } catch (error) {
        console.error("Hiba az adatok összesítésekor:", error);
      } finally {
        setLoading(false);
      }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const handleMergeAthletes = async () => {
    if (!primaryAthlete || selectedKeys.length < 2) return;
    setIsMerging(true);
    try {
      const primaryKey = `${primaryAthlete.category}|${primaryAthlete.license || primaryAthlete.name}`;
      const keysToChange = selectedKeys.filter(k => k !== primaryKey);

      const batch = writeBatch(db);
      let changedAny = false;

      // 1. Excel importok frissítése
      const importedRef = collection(db, "tournaments", id, "importedResults");
      const importedSnap = await getDocs(importedRef);

      importedSnap.forEach(importedDoc => {
        const data = importedDoc.data();
        let resultsChanged = false;
        const newResults = (data.results || []).map(res => {
          const cat = formatCategory(res.category || res.bowCategory);
          const resKey = res.license ? `${cat}|${res.license}` : `${cat}|${res.name || res.fullName}`;
          if (keysToChange.includes(resKey)) {
            resultsChanged = true;
            changedAny = true;
            return { ...res, name: primaryAthlete.name, fullName: primaryAthlete.name, license: primaryAthlete.license };
          }
          return res;
        });
        if (resultsChanged) batch.update(importedDoc.ref, { results: newResults });
      });

      // 2. Élő versenyek résztvevőinek frissítése (events / events_closed)
      if (tournament && tournament.rounds) {
        for (const round of tournament.rounds) {
          if (round.eventId) {
            for (const colName of ["events", "events_closed"]) {
              const pRef = collection(db, colName, round.eventId, "participants");
              const pSnap = await getDocs(pRef);
              pSnap.forEach(pDoc => {
                const pData = pDoc.data();
                const pCat = formatCategory(pData.bowCategory || pData.category);
                const pLic = pData.license || pData.competitionId || "";
                const pName = pData.fullName || pData.name || "";
                const pKey = pLic ? `${pCat}|${pLic}` : `${pCat}|${pName}`;

                if (keysToChange.includes(pKey)) {
                  changedAny = true;
                  batch.update(pDoc.ref, {
                    fullName: primaryAthlete.name,
                    name: primaryAthlete.name,
                    license: primaryAthlete.license,
                    licenseNumber: primaryAthlete.license
                  });
                }
              });
            }
          }
        }
      }

      if (changedAny) {
        await batch.commit();
        alert("Sikeres összevonás!");
      } else {
        alert("Nem találtam módosítható adatot.");
      }
      setShowMergeModal(false);
      setSelectedToMerge([]);
      setMergeMode(false);
      fetchData();
    } catch (error) {
      console.error("Hiba összevonáskor:", error);
      alert("Hiba történt az összevonás során.");
    } finally {
      setIsMerging(false);
    }
  };

  // --- ÚJ: SZÉTLÖVÉS MENTÉSE ---
  const handleSaveTournamentShootOff = async () => {
    setIsSavingShootOff(true);
    try {
      const tRef = doc(db, "tournaments", id);
      const newRanks = { ...(tournament.shootOffRanks || {}) };

      Object.entries(tempRanks).forEach(([key, rank]) => {
        if (rank) newRanks[key] = parseInt(rank);
      });

      await updateDoc(tRef, { shootOffRanks: newRanks });
      alert("Szétlövés eredményei rögzítve! 🏹✅");
      setShowShootOffModal(false);
      fetchData(); // Újratöltés
    } catch (error) {
      console.error("Hiba a szétlövés mentésekor:", error);
      alert("Hiba történt a mentés során.");
    } finally {
      setIsSavingShootOff(false);
    }
  };

  // --- EXCEL EXPORTÁLÁS A BAJNOKSÁG ÖSSZESÍTŐHÖZ ---
  const handleExportToExcel = () => {
    if (!mergedData || Object.keys(mergedData).length === 0) {
      alert("Nincsenek exportálható adatok!");
      return;
    }

    try {
      const exportData = [];
      const roundCount = tournament?.roundCount || 1;

      // Fejlécek
      const headers = ["Helyezés", "Név", "Egyesület", "Versenyengedély", "Íjkategória", "Korosztály", "Nem"];
      for (let i = 1; i <= roundCount; i++) {
        headers.push(`${i}. Forduló`);
      }
      headers.push("Összesített pontszám");

      // Cellaösszevonások gyűjtője
      const merges = [];
      let currentRowIndex = 0;

      // Végigmegyünk a kategóriákon (ABC sorrendben)
      const sortedCategories = Object.keys(mergedData).sort();

      sortedCategories.forEach(catKey => {
        const athletes = mergedData[catKey] || [];
        if (athletes.length === 0) return;

        const catName = bowTranslationMap[catKey] || catKey;

        // 1. Kategória Címsor
        const catHeaderRow = {};
        headers.forEach((h, idx) => {
          catHeaderRow[h] = idx === 0 ? `--- ${catName.toUpperCase()} ---` : "";
        });
        exportData.push(catHeaderRow);

        merges.push({
          s: { r: currentRowIndex, c: 0 },
          e: { r: currentRowIndex, c: headers.length - 1 }
        });
        currentRowIndex++;

        // 2. Oszlopfejlécek
        const colHeaderRow = {};
        headers.forEach(h => colHeaderRow[h] = h);
        exportData.push(colHeaderRow);
        currentRowIndex++;

        // 3. Versenyzők csoportosítása Korosztály + Nem szerint
        let lastGroupKey = "";
        let groupRank = 0;

        athletes.forEach(a => {
          const normAge = normalizeAge(a.age);
          const normGen = normalizeGender(a.gender);
          const ageLabel = translationMap[normAge] || a.age;
          const genderLabel = normGen === 'nő' ? "Nő" : "Férfi";

          const currentGroupKey = `${normAge}_${normGen}`;
          if (currentGroupKey !== lastGroupKey) {
            lastGroupKey = currentGroupKey;
            groupRank = 1;

            // Korosztály alcsoport címsor
            const subGroupRow = {};
            headers.forEach((h, idx) => {
              subGroupRow[h] = idx === 0 ? `>>> ${ageLabel} - ${genderLabel}` : "";
            });
            exportData.push(subGroupRow);

            merges.push({
              s: { r: currentRowIndex, c: 0 },
              e: { r: currentRowIndex, c: headers.length - 1 }
            });
            currentRowIndex++;
          } else {
            groupRank++;
          }

          const row = {};
          row["Helyezés"] = `${groupRank}.`;
          row["Név"] = a.name || "";
          row["Egyesület"] = a.club || "Egyéni induló";
          row["Versenyengedély"] = a.license || "-";
          row["Íjkategória"] = catName;
          row["Korosztály"] = ageLabel;
          row["Nem"] = genderLabel;

          for (let i = 0; i < roundCount; i++) {
            const scoreVal = a.scores[i];
            row[`${i + 1}. Forduló`] = scoreVal !== null && scoreVal !== undefined ? scoreVal : "-";
          }

          row["Összesített pontszám"] = a.total || 0;
          exportData.push(row);
          currentRowIndex++;
        });

        // Üres elválasztó sor
        const emptyRow = {};
        headers.forEach(h => emptyRow[h] = "");
        exportData.push(emptyRow);
        currentRowIndex++;
      });

      const worksheet = XLSX.utils.json_to_sheet(exportData, { header: headers, skipHeader: true });
      worksheet['!merges'] = merges;

      // Oszlopszélességek beállítása
      const wscols = [
        { wch: 10 }, // Helyezés
        { wch: 30 }, // Név
        { wch: 30 }, // Egyesület
        { wch: 18 }, // Versenyengedély
        { wch: 25 }, // Íjkategória
        { wch: 18 }, // Korosztály
        { wch: 10 }, // Nem
        ...Array.from({ length: roundCount }, () => ({ wch: 12 })), // Fordulók
        { wch: 22 }  // Összesített pontszám
      ];
      worksheet['!cols'] = wscols;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Bajnokság Összesítés");

      const tournamentName = tournament?.name?.replace(/\s+/g, '_') || 'osszesites';
      const fileName = `bajnoksag_osszesites_${tournamentName}_${new Date().toISOString().split('T')[0]}.xlsx`;

      XLSX.writeFile(workbook, fileName);
    } catch (e) {
      console.error("Hiba az Excel exportálásakor:", e);
      alert("Hiba történt az Excel fájl generálásakor.");
    }
  };

  const categories = useMemo(() => Object.keys(mergedData).sort(), [mergedData]);
  const currentAthletes = useMemo(() => mergedData[activeCategory] || [], [mergedData, activeCategory]);

  if (loading) {
    return <div style={{ padding: '50px', textAlign: 'center', color: '#b30000', fontWeight: 'bold' }}>Adatok összesítése... 🏹📈</div>;
  }

  const containerStyle = { padding: '20px', fontFamily: 'Arial, sans-serif', backgroundColor: '#f4f6f8', minHeight: '100vh' };
  const headerStyle = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', backgroundColor: '#fff', padding: '20px', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' };
  const tabContainerStyle = { display: 'flex', overflowX: 'auto', backgroundColor: '#e2e8f0', padding: '10px 10px 0 10px', borderRadius: '12px 12px 0 0', gap: '5px' };
  const tabStyle = (isActive) => ({ padding: '12px 25px', backgroundColor: isActive ? '#fff' : '#cbd5e0', color: isActive ? '#b30000' : '#4a5568', borderRadius: '8px 8px 0 0', cursor: 'pointer', fontWeight: 'bold', border: 'none', borderBottom: isActive ? '3px solid #b30000' : 'none' });
  const tableContainerStyle = { backgroundColor: '#fff', padding: '20px', borderRadius: '0 0 12px 12px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)', overflowX: 'auto' };
  const thStyle = { padding: '15px', borderBottom: '2px solid #edf2f7', color: '#718096', fontSize: '0.75rem', textTransform: 'uppercase', fontWeight: '900' };
  const tdStyle = { padding: '15px', borderBottom: '1px solid #edf2f7', color: '#2d3748', fontSize: '0.9rem' };

  return (
    <div style={containerStyle}>
      <button onClick={() => navigate('/egyesulet-dashboard')} style={{ display: 'flex', alignItems: 'center', gap: '8px', border: 'none', background: 'none', cursor: 'pointer', color: '#666', marginBottom: '20px', fontWeight: 'bold' }}>
        <FiArrowLeft /> Vissza az Irányítópultra
      </button>

      {/* --- DUPLIKÁCIÓ FIGYELMEZTETÉS BANNER --- */}
      {potentialDuplicatesCount > 0 && !mergeMode && (
        <div style={{
          backgroundColor: '#fff5f5', border: '1px solid #feb2b2', borderRadius: '12px',
          padding: '15px 20px', marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          boxShadow: '0 4px 6px rgba(179,0,0,0.05)', animation: 'fadeInDown 0.4s ease-out'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <div style={{ backgroundColor: '#feb2b2', padding: '10px', borderRadius: '50%', color: '#b30000' }}>
              <FiAlertTriangle size={24} />
            </div>
            <div>
              <h4 style={{ margin: 0, color: '#c53030' }}>Gyanús adatok az eredménylistában!</h4>
              <p style={{ margin: '3px 0 0 0', fontSize: '0.9rem', color: '#666' }}>
                Úgy tűnik, <strong>{potentialDuplicatesCount} esetben</strong> hasonló nevek szerepelnek a listában (pl. elgépelt ékezet).
              </p>
            </div>
          </div>
          <button
            onClick={() => setMergeMode(true)}
            style={{
              backgroundColor: '#b30000', color: 'white', border: 'none', padding: '10px 20px',
              borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', transition: '0.2s'
            }}
          >
            Javítás most
          </button>
        </div>
      )}

      <div style={headerStyle}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <FiAward size={30} color="#b30000" />
          <div>
            <h2 style={{ margin: 0 }}>{tournament?.name}</h2>
            <div style={{ display: 'flex', gap: '15px', fontSize: '0.8rem' }}>
              <span style={{ fontWeight: 'bold', color: '#b30000' }}>
                Szabály: {SCORING_RULE_LABELS[tournament?.scoringRule] || tournament?.scoringRule || 'Összesített'}
              </span>
              <span>Min. részvétel: {tournament?.minParticipation || 1} ford.</span>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button onClick={() => { setMergeMode(!mergeMode); setSelectedToMerge([]); }} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 20px', backgroundColor: mergeMode ? '#333' : '#fff', color: mergeMode ? '#fff' : '#333', border: '1px solid #ddd', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>
            <FiEdit3 /> {mergeMode ? "Mégse" : "Duplikációk javítása"}
          </button>
          <button onClick={handleExportToExcel} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 20px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>
            <FiDownload /> Excel Export
          </button>
        </div>
      </div>

      <div style={tabContainerStyle}>
        {categories.map(cat => (
          <button key={cat} style={tabStyle(activeCategory === cat)} onClick={() => setActiveCategory(cat)}>{cat}</button>
        ))}
      </div>

      <div style={tableContainerStyle}>
        {activeCategory ? (
          <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
            <thead>
              <tr>
                <th style={{ ...thStyle, width: '40px' }}>#</th>
                <th style={thStyle}>Név / Egyesület</th>
                <th style={thStyle}>V.eng</th>
                <th style={thStyle}>Kor / Nem</th>
                {Array.from({ length: tournament?.roundCount || 1 }).map((_, i) => (
                  <th key={i} style={{ ...thStyle, textAlign: 'center' }}>{i + 1}. Ford.</th>
                ))}
                <th style={{ ...thStyle, textAlign: 'center', color: '#b30000' }}>ÖSSZESÍTETT</th>
              </tr>
            </thead>
            <tbody>
              {(() => {
                let lastGroup = "";
                let groupRank = 0;

                const filteredAthletes = mergeMode
                  ? currentAthletes.filter(a => a.isPotentialDuplicate)
                  : currentAthletes;

                return filteredAthletes.map((p, idx) => {
                  const normAge = normalizeAge(p.age);
                  const normGen = normalizeGender(p.gender);
                  const ageLabel = translationMap[normAge] || p.age;
                  const genderLabel = normGen === 'nő' ? "Nő" : "Férfi";

                  const currentGroupKey = `${normAge}_${normGen}`;
                  const isNewGroup = currentGroupKey !== lastGroup;

                  if (isNewGroup) {
                    lastGroup = currentGroupKey;
                    groupRank = 1;
                  } else {
                    groupRank++;
                  }

                  const participationCount = p.scores.filter(s => s !== null).length;
                  const isEligible = participationCount >= (tournament?.minParticipation || 1);
                  const pKey = p.license ? `${p.category}|${p.license}` : `${p.category}|${p.name}`;

                  const isSelected = selectedKeys.includes(pKey);
                  let rowBg = 'transparent';
                  if (isSelected) rowBg = '#fff3cd';
                  else if (p.needsShootOff) rowBg = 'rgba(220, 53, 69, 0.05)';
                  else if (p.isPotentialDuplicate) rowBg = '#fff9c4';
                  else if (!isEligible) rowBg = '#f9f9f9';

                  let podiumDisplay = groupRank + ".";
                  if (p.needsShootOff) {
                    podiumDisplay = <FiAlertCircle size={20} color="#dc3545" title="Szétlövés szükséges!" />;
                  }

                  return (
                    <React.Fragment key={pKey}>
                      {isNewGroup && (
                        <tr style={{ backgroundColor: '#f1f1f1' }}>
                          <td colSpan={6 + (tournament?.roundCount || 1)} style={{
                            padding: '12px 15px',
                            fontWeight: 'bold',
                            color: '#b30000',
                            fontSize: '0.9rem',
                            textTransform: 'uppercase',
                            letterSpacing: '1px',
                            borderBottom: '2px solid #ddd'
                          }}>
                            {ageLabel} - {genderLabel}
                          </td>
                        </tr>
                      )}
                      <tr
                        onClick={() => mergeMode && setSelectedToMerge(prev => prev.includes(pKey) ? prev.filter(k => k !== pKey) : [...prev, pKey])}
                        style={{
                          transition: '0.2s',
                          opacity: (isEligible || mergeMode) ? 1 : 0.6,
                          backgroundColor: rowBg,
                          cursor: mergeMode ? 'pointer' : 'default',
                          borderLeft: p.needsShootOff ? '4px solid #b30000' : 'none'
                        }}
                      >
                        <td style={{ ...tdStyle, fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '10px' }}>
                          {mergeMode && (
                            <input type="checkbox" checked={isSelected} onChange={() => {}} style={{ width: '18px', height: '18px', accentColor: '#b30000' }} />
                          )}
                          <span style={{ color: (isEligible || mergeMode) && groupRank <= 3 && !p.needsShootOff ? '#b30000' : '#718096' }}>
                            {podiumDisplay}
                          </span>
                        </td>
                        <td style={tdStyle}>
                          <div style={{ fontWeight: 'bold', color: '#333', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {p.name}
                            {p.isPotentialDuplicate && !mergeMode && <FiAlertTriangle size={14} color="#d69e2e" title="Hasonló név található!" />}
                            {tournament.shootOffRanks?.[pKey] && <span style={{ fontSize: '0.7rem', color: '#b30000', backgroundColor: '#fff', border: '1px solid #b30000', padding: '1px 5px', borderRadius: '4px' }}>Szétlövés: {tournament.shootOffRanks[pKey]}.</span>}
                          </div>
                          <div style={{ fontSize: '0.75rem', color: '#888' }}>{p.club || "Egyéni induló"}</div>
                        </td>
                        <td style={tdStyle}>{p.license || "-"}</td>
                        <td style={tdStyle}>
                          <div style={{ fontSize: '0.85rem' }}>{ageLabel}</div>
                          <div style={{ fontSize: '0.75rem', color: '#666' }}>{genderLabel}</div>
                        </td>
                        {p.scores.map((score, sIdx) => {
                          const isBestTwo = tournament?.scoringRule === 'best_two' && score !== null;
                          let isTopTwo = false;
                          if (isBestTwo) {
                            const sortedIndices = p.scores
                              .map((s, idx) => ({ s, idx }))
                              .filter(x => x.s !== null)
                              .sort((a, b) => b.s - a.s)
                              .slice(0, 2)
                              .map(x => x.idx);
                            isTopTwo = sortedIndices.includes(sIdx);
                          }

                          return (
                            <td key={sIdx} style={{
                              ...tdStyle,
                              textAlign: 'center',
                              color: score === null ? '#ccc' : (isTopTwo ? '#b30000' : '#333'),
                              fontWeight: isTopTwo ? 'bold' : 'normal'
                            }}>
                              {score !== null ? score : "-"}
                            </td>
                          );
                        })}
                        <td style={{ ...tdStyle, textAlign: 'center', fontWeight: '900', color: '#b30000', backgroundColor: (isEligible || mergeMode) ? '#fff5f5' : '#eee' }}>
                          {p.total}
                          {(!isEligible && !mergeMode) && <div style={{ fontSize: '0.6rem', fontWeight: 'normal', color: '#888' }}>Nem értékelhető</div>}
                        </td>
                      </tr>
                      {p.needsShootOff && (!filteredAthletes[idx + 1] || !filteredAthletes[idx + 1].needsShootOff) && (
                        <tr>
                          <td colSpan={6 + (tournament?.roundCount || 1)} style={{ padding: '10px 15px', textAlign: 'left', backgroundColor: 'rgba(220, 53, 69, 0.02)' }}>
                             <button
                               onClick={() => {
                                 const tieGroup = [];
                                 let j = idx;
                                 while (j >= 0 && filteredAthletes[j].needsShootOff) {
                                   tieGroup.unshift(filteredAthletes[j]);
                                   j--;
                                 }
                                 setShootOffGroup(tieGroup);
                                 setTempRanks({});
                                 setShowShootOffModal(true);
                               }}
                               style={{
                                 backgroundColor: '#fff', color: '#b30000', border: '2px solid #b30000',
                                 padding: '6px 15px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer',
                                 fontSize: '0.8rem', display: 'flex', alignItems: 'center', gap: '8px'
                               }}
                             >
                               <FiAlertCircle /> Szétlövés rögzítése
                             </button>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                });
              })()}
            </tbody>
          </table>
        ) : <p style={{ textAlign: 'center', padding: '40px', color: '#999' }}>Válassz kategóriát!</p>}
      </div>

      {/* MODALS */}
      {mergeMode && selectedKeys.length > 0 && (
        <div style={{ position: 'fixed', bottom: '30px', left: '50%', transform: 'translateX(-50%)', backgroundColor: '#333', color: '#fff', padding: '15px 30px', borderRadius: '50px', display: 'flex', gap: '20px', boxShadow: '0 10px 25px rgba(0,0,0,0.3)', zIndex: 1000 }}>
          <span>{selectedKeys.length} kijelölve</span>
          <button disabled={selectedKeys.length < 2} onClick={() => {
            const sels = currentAthletes.filter(a => selectedKeys.includes(a.license ? `${a.category}|${a.license}` : `${a.category}|${a.name}`));
            setPrimaryAthlete(sels[0]); setShowMergeModal(true);
          }} style={{ backgroundColor: selectedKeys.length < 2 ? '#666' : '#b30000', color: '#fff', border: 'none', padding: '8px 20px', borderRadius: '20px', fontWeight: 'bold' }}>Összevonás</button>
          <button onClick={() => setSelectedToMerge([])} style={{ background: 'none', border: 'none', color: '#aaa' }}>Mégse</button>
        </div>
      )}

      {showMergeModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1100 }}>
          <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '15px', maxWidth: '500px', width: '90%' }}>
            <h3 style={{ color: '#b30000' }}>Összevonás megerősítése</h3>
            <p style={{ fontSize: '0.9rem', color: '#666' }}>Melyik név maradjon?</p>
            {currentAthletes.filter(a => selectedKeys.includes(a.license ? `${a.category}|${a.license}` : `${a.category}|${a.name}`)).map((a, i) => (
              <div key={i} onClick={() => setPrimaryAthlete(a)} style={{ padding: '10px', border: `2px solid ${primaryAthlete === a ? '#b30000' : '#eee'}`, borderRadius: '8px', marginBottom: '10px', cursor: 'pointer' }}>
                <strong>{a.name}</strong> (V.eng: {a.license || "nincs"})
              </div>
            ))}
            <div style={{ display: 'flex', gap: '15px', marginTop: '20px' }}>
              <button onClick={() => setShowMergeModal(false)} style={{ flex: 1, padding: '10px', borderRadius: '8px', border: '1px solid #ccc' }}>Mégse</button>
              <button onClick={handleMergeAthletes} style={{ flex: 1, padding: '10px', borderRadius: '8px', border: 'none', backgroundColor: '#b30000', color: '#fff', fontWeight: 'bold' }}>Véglegesítés</button>
            </div>
          </div>
        </div>
      )}

      {showShootOffModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1100 }}>
          <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '15px', maxWidth: '450px', width: '90%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '2px solid #b30000', paddingBottom: '10px' }}>
              <h3 style={{ margin: 0, color: '#b30000' }}>Szétlövés rögzítése</h3>
              <FiX style={{ cursor: 'pointer' }} onClick={() => setShowShootOffModal(false)} />
            </div>
            <p style={{ fontSize: '0.85rem', color: '#666', marginBottom: '20px' }}>
              Add meg az íjászok helyezését a szétlövés alapján (1., 2., stb.):
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '25px' }}>
              {shootOffGroup.map(p => {
                const pKey = p.license ? `${p.category}|${p.license}` : `${p.category}|${p.name}`;
                return (
                  <div key={pKey} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f9f9f9', padding: '10px', borderRadius: '8px', border: '1px solid #eee' }}>
                    <div style={{ fontWeight: 'bold', fontSize: '0.9rem' }}>{p.name}</div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span style={{ fontSize: '0.8rem' }}>Hely:</span>
                      <input
                        type="number"
                        min="1"
                        style={{ width: '60px', padding: '5px', borderRadius: '4px', border: '1px solid #ccc', textAlign: 'center' }}
                        value={tempRanks[pKey] || ''}
                        onChange={(e) => setTempRanks({ ...tempRanks, [pKey]: e.target.value })}
                        placeholder="-"
                      />
                    </div>
                  </div>
                );
              })}
            </div>
            <div style={{ display: 'flex', gap: '15px' }}>
              <button onClick={() => setShowShootOffModal(false)} style={{ flex: 1, padding: '12px', borderRadius: '8px', border: '1px solid #ccc', cursor: 'pointer' }}>Mégse</button>
              <button
                onClick={handleSaveTournamentShootOff}
                disabled={isSavingShootOff}
                style={{ flex: 2, padding: '12px', borderRadius: '8px', border: 'none', backgroundColor: '#28a745', color: '#fff', fontWeight: 'bold', cursor: 'pointer' }}
              >
                {isSavingShootOff ? "Mentés..." : "Eredmények mentése"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TournamentSummary;
